import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpHeaders} from '@angular/common/http';
import { AuthService } from '../system/auth.service';
import { LoginService } from '../api/Services/security/login.service';
import { ParametersService } from '../api/Services/configuration/parameters.service';
import { HomeComponent } from '../modules/home/home.component';
import { Tab } from '../tabconfig/tab.model';
import { TabService } from '../tabconfig/tab.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public form: FormGroup;
  public formFake: FormGroup;
  
  public tabs: Tab[] = [
    new Tab(HomeComponent, "Inicio", { parent: "AppComponent" })
  ];
  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private loginService: LoginService,
    private parameterService: ParametersService,
    private authService: AuthService,
    private tabService: TabService,
    private router: Router
    ) {

     }

  ngOnInit(): void {
    this.initForm();
  }

  public initForm() {
    this.form = this.formBuilder.group({
      user_vc_login: [null, Validators.required],
      user_tx_password: [null, Validators.required]
    });
  }

  public login():void{
    
    if (this.form.valid) {
      const credenciales = btoa(this.form.controls['user_vc_login'].value + '|' + this.form.controls['user_tx_password'].value);
      const httpHeaders = new HttpHeaders({
        Authorization: 'Basic ' + credenciales
      });
  
      this.tabs  = [
        new Tab(HomeComponent, "Inicio", { parent: "AppComponent" })
      ];
      this.loginService.Login(this.form.getRawValue()).subscribe(
        data => {
          if (data) {
            let result = data['data'][0];
            if(result.ERR==0){
              localStorage.clear();
              this.parameterService.GetAll().subscribe(dataParameter=>{
                this.authService.setToken(data['token'], result.LOGIN,result.RESULT,result.EMP_BI_ID,result.ROL_ID, result.ROL,dataParameter);
                this.tabService.tabs = this.tabs;
                this.tabService.tabSub = new BehaviorSubject<Tab[]>(this.tabs);
               
                this.router.navigate(['/dashboard']);
                this.toastr.success('Bienvenido', 'Success');
              });
              
            }
            else{
              this.toastr.warning('credenciales incorrectas', 'Advertencia');
            }
    
           
          }
          /*
          if (data.token) {
            this.authService.setToken(data.token, data.user, data.perfil);
            this.router.navigate(['/dashboard']);
            this.toastr.success('Bienvenido', 'Success');
          }
          */
        }
      );
       

     /* 
        this.authService.setToken('bff149a0b87f5b0e00d9dd364e9ddaa0', 'JCAYCHO', 1);
        this.router.navigate(['/dashboard']);
        this.toastr.success('Bienvenido', 'Success');
      */
    } else {
      this.toastr.warning('Debe ingresar usuario y contraseña', 'Advertencia');
    }

  }
}
